/** Application role, stored in the UserRoles list (spec §2). */
export type Role = 'Auditor' | 'DM' | 'StoreTeam' | 'Admin' | 'Executive';

export const ALL_ROLES: readonly Role[] = [
  'Auditor',
  'DM',
  'StoreTeam',
  'Admin',
  'Executive',
];

export interface Store {
  id: string;
  storeNumber: string;
  name: string;
  district: string;
  region: string;
  state: string;
  address: string;
  city: string;
  zip: string;
  phone: string;
  /**
   * The store's owner (Owners list item id; owner ruling 2026-10-28 — we
   * manage some stores for third-party owners). null = none set. Staff see
   * it; store teams never (the Owners list is staff-only).
   */
  ownerId: number | null;
  /** Full site name of this store's hub; empty for hubs/standalone sites. */
  hubSite: string;
  /** Shared store account UPN, e.g. Alexandria@selfstorageplus.com */
  managerEmail: string;
  dmName: string;
  dmUpn: string;
  active: boolean;
  /** Tri-state facility attribute: 'unknown' = data never captured. */
  parking: 'yes' | 'no' | 'unknown';
  /** null = unknown; 0 = explicitly no elevators; N = that many elevators. */
  elevatorCount: number | null;
  /**
   * Long distance (flight + hotel; owner ruling 2026-10-20): DM and Auditor
   * clocks use each template's long-distance window when it sets one.
   */
  longDistance: boolean;
}

/** A UserRoles row grants a role to a single user (by UPN) or an Entra security group (by object ID). */
export type PrincipalType = 'user' | 'group';

export interface UserRole {
  id: string;
  principalType: PrincipalType;
  /** Sign-in UPN when principalType = 'user'. */
  upn: string;
  /** Entra group object ID when principalType = 'group'. */
  groupId: string;
  displayName: string;
  role: Role;
  /** Whole districts granted; scoped roles (DM/StoreTeam) only. */
  districts: string[];
  /** Individual stores granted (by StoreNumber); scoped roles only. */
  storeNumbers: string[];
  active: boolean;
}

/** The signed-in user with resolved role + scope, attached to app context. */
export interface AppUser {
  upn: string;
  displayName: string;
  role: Role;
  districts: string[];
  storeNumbers: string[];
}
